import Axios from "axios";

export class UploadCommunicator {
  async uploadFile(presignedUrl, selectedFile, updateUploadProgressHandler) {
    console.log('uploadFile', presignedUrl, selectedFile);
    if (selectedFile) {
      try {
        await Axios.put(presignedUrl, selectedFile, {
          headers: {
            'Content-Type': selectedFile.contentType,
          },
          onUploadProgress: async (event) => {
              //console.log('got upload progress', event.event);
              await updateUploadProgressHandler(event);
          },
        });
      } catch (error) {
        console.log('Error uploading file:', error);
        throw error;
      }
    }
  }
}
